import { Component, Input, OnInit, OnDestroy } from '@angular/core';

@Component({
    selector: 'app-clock',
    templateUrl: './clock.component.html',
    styleUrls: ['./clock.component.less']
})
export class ClockComponent implements OnInit, OnDestroy {
    @Input() format = 'yyyy-MM-dd HH:mm:ss'; // Default date and time format

    currentDateTime: Date = new Date();
    private timer: any;

    ngOnInit() {
        // Update the current date and time every second
        this.timer = setInterval(() => {
            this.currentDateTime = new Date();
        }, 1000);
    }

    ngOnDestroy() {
        // Clear the timer to prevent memory leaks
        if (this.timer) {
            clearInterval(this.timer);
        }
    }
}
